import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IvyCarouselModule } from 'angular-responsive-carousel';

@Component({
  selector: 'app-category-container',
  templateUrl: './category-container.component.html',
  styleUrls: ['./category-container.component.scss']
})
export class CategoryContainerComponent implements OnInit {

  categoryList = [
    { icon: 'phone', label: 'Phones & Tablets', categoryId: 366 },
    { icon: 'home', label: 'Home Appliances', categoryId: 171 },
    { icon: 'baby', label: 'Baby & Kids', categoryId: 191 },
    { icon: 'health', label: 'Health & Beauty', categoryId: 181 },
    { icon: 'house', label: 'Home & Lifestyle', categoryId: 214 },
    { icon: 'car', label: 'Automotive', categoryId: 676 },
    { icon: 'computer', label: 'Computer & Staionery', categoryId: 0 },
    { icon: 'camera', label: 'Camera', categoryId: 0 },
    { icon: 'sports', label: 'Sports & Outdoors', categoryId: 438 },
    { icon: 'diamond', label: 'Bags & Jewelry', categoryId: 2024 },
    { icon: 'watch', label: 'Watches', categoryId: 230 },
    { icon: 'airplane', label: 'Travel & Luggage', categoryId: 2337 },
    { icon: 'voucher', label: 'Vouchers', categoryId: 0 },
    { icon: 'grocery', label: 'Grocery', categoryId: 239 },
    { icon: 'fee', label: 'Fee Waiver', link: 'https://www.rhb.com.my' },
  ];

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  updateImage(category, type) {
    if (type === 'in') {
      category.icon = `${category.icon}-hover`;
    } else {
      category.icon = category.icon.replace('-hover', '');
    }
  }

  navigate(categoryId, isLink = false) {
    this.router.navigate(['/product/listing'], { queryParams: { categoryId }})
  }

}
